<template>
  <Dialog
    :visible="modelValue"
    modal
    header="Redeem Code"
    @update:visible="onVisible"
  >
    <div class="flex flex-col gap-3">
      <InputText
        v-model="code"
        placeholder="Enter code"
        autocomplete="off"
      />
      <div class="flex gap-2 justify-end">
        <Button
          label="Cancel"
          severity="secondary"
          @click="emit('update:modelValue', false)"
        />
        <Button
          label="Redeem"
          :loading="loading"
          @click="onRedeem"
        />
      </div>
      <Message
        v-if="message"
        :severity="messageSeverity"
      >
        {{ message }}
      </Message>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', v: boolean): void, (e: 'redeemed', info: { year: string, subkreweId: string }): void }>()

const code = ref('')
const loading = ref(false)
const message = ref('')
const messageSeverity = ref<'success' | 'error' | 'info' | 'warn'>('info')

watch(() => props.modelValue, (v) => {
  if (!v) {
    code.value = ''
    message.value = ''
  }
})

function onVisible(v: boolean) {
  emit('update:modelValue', v)
}

async function onRedeem() {
  if (!code.value) return
  loading.value = true
  message.value = ''
  try {
    const res = await $fetch('/api/pool/redeem', { method: 'POST', body: { code: code.value } }) as { success: boolean, year?: string, subkreweId?: string, message?: string }
    if (res.success) {
      messageSeverity.value = 'success'
      message.value = `Redeemed for ${res.year}`
      emit('redeemed', { year: String(res.year || ''), subkreweId: String(res.subkreweId || '') })
      emit('update:modelValue', false)
    }
    else {
      messageSeverity.value = 'error'
      message.value = res.message || 'Redeem failed'
    }
  }
  catch (e) {
    messageSeverity.value = 'error'
    message.value = e instanceof Error ? e.message : 'Redeem failed'
  }
  finally {
    loading.value = false
  }
}
</script>
